<template>
  <div class="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.grid {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 30px;
  & > div {
    width: calc((100% - 60px) / 4);
    margin-bottom: 54px;
    margin-right: 20px;
  }
  & > div:nth-child(4n) {
    margin-right: 0;
  }
}
</style>
